export default __webpack_public_path__ + "static/media/trans-5.3c279fa1.jpg";